<div class="d-flex flex-column card" *ngIf="canvas && loadComplete">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ canvas.displayName || canvas.name }}</div>
		<div class="ms-auto">
			<app-record-control-footer
				(onCancelChange)="onClose()"
				(onSaveChange)="validateForSave()"
				[saveDisabled]="(!canvas.name && !canvas.canvasKey) || !changesToSave"
				(onDeleteChange)="canvasDelete(canvas)"
				[deleteDisabled]="canvas.canvasKey < 10000"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>

	<p-tabView [(activeIndex)]="viewTab" (onChange)="onTabChange($event)">
		<p-tabPanel header="Items" *ngIf="!canvas.includedItemCanvas">
			<div class="d-flex w-100">
				<div class="ms-auto mb-2">
					<p-splitButton
						[disabled]="canvas.sharedFrom"
						label="Toggle Online"
						icon="pi pi-power-off"
						(onClick)="toggleAllOnlineOffline(true)"
						[model]="canvasItemMultiActionButton"
						styleClass="p-button-secondary p-button-raised m-2"
					>
					</p-splitButton>

					<p-button pRipple styleClass="p-button-raised p-button-warning m-2" (click)="sbReorderCanvasItems.open()" [disabled]="canvas.sharedFrom">
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'sort-shapes-down']" size="lg" class="ms-1 me-2"></fa-icon>
								Sort canvas items
							</div>
						</ng-template>
					</p-button>
					<p-button
						pRipple
						styleClass="p-button-raised p-button-primary m-2"
						(click)="newRecord = true; ooCanvasMenuItemAdd()"
						[disabled]="canvas.sharedFrom"
					>
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
								Add item to canvas
							</div>
						</ng-template>
					</p-button>
				</div>
			</div>

			<p-table
				#dt
				responsiveLayout="stack"
				[value]="ooCanvasMenuItems"
				[loading]="!ooCanvasMenuItems"
				[globalFilterFields]="app.keys(ooCanvasMenuItems)"
				[rowHover]="true"
				[rows]="10"
				[showCurrentPageReport]="true"
				[rowsPerPageOptions]="[10, 25, 50]"
				responsiveLayout="scroll"
				[paginator]="true"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items"
			>
				<ng-template pTemplate="caption">
					<div class="table-header d-flex">
						<div class="flex-grow-1">
							<span class="p-float-label p-input-icon-left m-2 w-100">
								<i class="pi pi-search"></i>
								<input
									pInputText
									class="w-100"
									id="globalSearch"
									name="globalSearch"
									style="width: 100%"
									type="text"
									(input)="dt.filterGlobal($event.target.value, 'contains')"
								/>
								<label for="globalSearch">Search...</label>
							</span>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th class="d-flex flex-column">
							<div>Name</div>
							<div class="text-italics">Display Name</div>
						</th>
						<th>Description</th>
						<th>Online</th>
						<th>Price</th>
						<th style="text-align: right"></th>
					</tr>
				</ng-template>
				<ng-template let-rec pTemplate="body" let-rowIndex="rowIndex">
					<tr>
						<td class="d-flex flex-column">
							<div>
								{{ rec.ooMenuItem.name }}
							</div>
							<div class="text-italics">
								{{ rec.displayName || rec.ooMenuItem?.name }}
							</div>
						</td>
						<td>
							{{ rec.description }}
						</td>
						<td class="justify-content-center">
							<p-inputSwitch [(ngModel)]="rec.online" (onChange)="saveCanvasMenuItem(rec)" [disabled]="true"></p-inputSwitch>
						</td>
						<td class="justify-content-center">
							{{ venueSvc.menuItemGetPriceFromNumber(rec.ooMenuItem, rec.priceNumber) | currency }}
						</td>
						<td style="text-align: right" class="d-flex">
							<div class="d-flex flex-column">
								<div
									*ngIf="rec.venueKey && rec.venueKey !== venueSvc.subscriptionVenue.value.key"
									class="display-14 text-danger text-italics justify-content-center text-center"
								>
									This item is not available at this venue
								</div>

								<div class="d-flex flex-column">
									<p-button
										pRipple
										styleClass="p-button-raised p-button-secondary m-2"
										[disabled]="canvas.sharedFrom"
										(click)="newRecord = false; ooCanvasMenuItemSelected = rec"
									>
										<ng-template pTemplate="content">
											<div class="d-flex justify-content-center">
												<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1 me-2"></fa-icon>
												Edit
											</div>
										</ng-template>
									</p-button>
									<p-button
										pRipple
										styleClass="p-button-raised p-button-primary m-2"
										[disabled]="canvas.sharedFrom"
										(click)="menuItemSelected = rec.ooMenuItem"
									>
										<ng-template pTemplate="content">
											<div class="d-flex justify-content-center">
												<fa-icon [icon]="['far', 'question-circle']" size="lg" class="ms-1 me-2"></fa-icon>
												Item
											</div>
										</ng-template>
									</p-button>
									<app-record-control-footer
										[hideAdd]="true"
										[hideCancel]="true"
										[hideDelete]="false"
										[hideSave]="true"
										(onDeleteChange)="onOOCanvasMenuItemRemove(rec)"
										[deleteDisabled]="canvas.sharedFrom"
									></app-record-control-footer>
								</div>
							</div>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="canvas.includedItemCanvas" header="Kiosk Items">
			<app-canvas-item-included-list *ngIf="canvas.includedItemCanvas" [canvasKeySelected]="canvas.canvasKey"> </app-canvas-item-included-list>
		</p-tabPanel>
		<p-tabPanel header="Settings">
			<div class="p-grid">
				<div class="p-col-12 p-md-3 p-lg-3">
					<div class="d-flex flex-column">
						<span class="p-float-label p-input-icon-right mt-4">
							<i
								*ngIf="canvas.canvasKey < 1000"
								class="pi pi-lock"
								pTooltip="Names for canvases originating from the store-level cannot be edited"
							></i>
							<i *ngIf="canvas.canvasKey > 1000" class="pi pi-lock-open"></i>
							<input
								pInputText
								type="text"
								[readonly]="canvas.canvasKey < 10000"
								name="name"
								id="name"
								[(ngModel)]="canvas.name"
								(change)="changesToSave = true"
								class="w-100 m-2"
							/>
							<label for="name" class="ms-2">Canvas Name</label>
						</span>
						<span class="p-float-label mt-4">
							<input
								pInputText
								type="text"
								name="displayName"
								[(ngModel)]="canvas.displayName"
								(change)="changesToSave = true"
								id="displayName"
								class="w-100 m-2"
							/>
							<label for="displayName" class="ms-2">Display Name</label>
						</span>
					</div>
				</div>
				<div class="p-col-12 p-md-3 p-lg-3">
					<span class="p-float-label mt-4 h-75">
						<textarea
							pInputTextarea
							[(ngModel)]="canvas.description"
							id="description"
							style="width: 100%; height: 100%; max-width: 100%"
							class="mt-1"
							(change)="changesToSave = true"
						></textarea>
						<label for="description" class="ms-2">Canvas Description</label>
					</span>
				</div>
				<div class="p-col-12 p-md-3 p-lg-3">
					<div class="d-flex flex-column justify-content-end">
						<div class="p-grid mt-4">
							<div class="p-col">Online</div>
							<p-inputSwitch styleClass="mx-2 p-col" (onChange)="changesToSave = true" [(ngModel)]="canvas.online"> </p-inputSwitch>
						</div>
						<div class="p-grid" *ngIf="userSvc.user.role === 6">
							<div class="p-col">Included Item Canvas</div>
							<p-inputSwitch styleClass="mx-2 p-col" (onChange)="changesToSave = true" [(ngModel)]="canvas.includedItemCanvas"> </p-inputSwitch>
						</div>
						<div class="p-grid" *ngIf="userSvc.user.role === 6">
							<div class="p-col">Subscription Canvas</div>
							<p-inputSwitch styleClass="mx-2 p-col" (onChange)="changesToSave = true" [(ngModel)]="canvas.subscriptionCanvas"> </p-inputSwitch>
						</div>
						<div class="p-grid mt-4">
							<div class="p-col">Mark Items Online Automatically</div>
							<p-inputSwitch
								styleClass="mx-2 p-col"
								[disabled]="canvas.includedItemCanvas"
								(onChange)="changesToSave = true"
								[(ngModel)]="canvas.defaultOnline"
							>
							</p-inputSwitch>
						</div>
						<div class="p-grid">
							<div class="p-col">Taxable Automatically</div>
							<p-inputSwitch
								styleClass="mx-2 p-col"
								[disabled]="canvas.includedItemCanvas"
								(onChange)="changesToSave = true"
								[(ngModel)]="canvas.defaultTaxable"
							>
							</p-inputSwitch>
						</div>
						<div class="p-grid">
							<div class="p-col">Hide Images</div>
							<p-inputSwitch
								styleClass="mx-2 p-col"
								[disabled]="canvas.includedItemCanvas"
								(onChange)="changesToSave = true"
								[(ngModel)]="canvas.hideImages"
							>
							</p-inputSwitch>
						</div>
						<div class="p-grid mt-3">
							<div class="p-col">
								<span class="p-float-label">
									<p-dropdown
										#defaultPriceNumberList
										(onChange)="changesToSave = true"
										[disabled]="canvas.includedItemCanvas"
										[options]="priceNumberList"
										[autoDisplayFirst]="false"
										optionLabel="label"
										optionValue="value"
										name="priceNumberList"
										[(ngModel)]="canvas.defaultItemPriceNumber"
										[style]="{ width: '100%' }"
										appendTo="body"
									>
									</p-dropdown>
									<label for="defaultPriceNumberList">Default Menu Item Price Number</label>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="p-col-12 p-md-3 p-lg-3 d-flex flex-column">
					<p-dropdown
						[placeholder]="timeRangeListLoadingPlaceholder"
						[disabled]="canvas.includedItemCanvas"
						[options]="venueSvc.timeRanges"
						(onChange)="changesToSave = true"
						optionLabel="name"
						[filter]="true"
						filterBy="name"
						optionValue="key"
						name="timeRangeList"
						(onChange)="timeRangeSelect($event)"
						[virtualScroll]="true"
						virtualScrollItemSize="30"
						[style]="{ width: '100%' }"
						styleClass="m-2"
						appendTo="body"
					>
					</p-dropdown>
					<div class="d-flex flex-row mt-2">
						<div *ngFor="let canvasItemTimeRange of canvas.OOCanvasTimeRange">
							<p-tag
								value="{{ canvasItemTimeRange.name }}"
								severity="danger"
								icon="pi pi-times"
								styleClass="mx-2"
								(click)="timeRangeRemove(canvasItemTimeRange.timeRangeKey)"
							></p-tag>
						</div>
					</div>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel header="Image">
			<div class="d-flex">
				<img
					*ngIf="canvas.imageKey"
					class="w-100 m-2"
					[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueSvc.venueKey + '/' + canvas.imageKey + '?' + timestamp"
					style="width: 80px; height: auto"
				/>
			</div>
			<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="selectCanvasImage(canvas.canvasKey)">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'camera']" size="lg" class="ms-1 me-2"></fa-icon>
						Add Image
					</div>
				</ng-template>
			</p-button>
			<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="canvasRemoveImage(canvas.canvasKey)">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'camera-slash']" size="lg" class="ms-1 me-2"></fa-icon>
						Remove Image
					</div>
				</ng-template>
			</p-button>
		</p-tabPanel>
		<p-tabPanel header="Subscriptions" *ngIf="canvas.subscriptionCanvas">
			<app-canvas-subscription-setup [canvasIndex]="canvasIndex"></app-canvas-subscription-setup>
		</p-tabPanel>
	</p-tabView>
</div>

<focus-sidebar #sbReorderCanvasItems header="Reorder Canvas Items" [showCloseIcon]="true" size="xxs" [dismissible]="false" (onClose)="onOOCanvasItemReorder()">
	<p-orderList [value]="ooCanvasMenuItems">
		<ng-template let-item pTemplate="item">
			<div>
				{{ item.displayName || item.ooMenuItem?.name }}
			</div>
		</ng-template>
	</p-orderList>
</focus-sidebar>

<app-canvas-menu-item-createEdit
	*ngIf="ooCanvasMenuItemSelected"
	[newRecord]="newRecord"
	[ooCanvasMenuItem]="ooCanvasMenuItemSelected"
	[sourceComponent]="'canvas'"
	[venueKey]="venueSvc.venueKey"
	(ooCanvasMenuItemEmitter)="onNewEditOOCanvasMenuItemReturn($event)"
	(closeEmitter)="onAddItemClear()"
	[ooCanvas]="canvas"
></app-canvas-menu-item-createEdit>

<p-dialog
	*ngIf="menuItemSelected"
	[(visible)]="menuItemSelected"
	[closable]="true"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '75vw' }"
>
	<app-menu-item-record-setup
		[menuItemKey]="menuItemSelected.menuItemKey"
		(onMenuItemCanvasSaveEmitter)="returnFromMenuItemInspector($event)"
		(onMenuItemCanvasClearEmitter)="menuItemSelected = undefined"
	></app-menu-item-record-setup>
</p-dialog>

<p-dialog *ngIf="togglePrice" [(visible)]="togglePrice" [closable]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<fa-icon [icon]="['far', 'dollar-sign']" class="me-4" size="lg"></fa-icon>
		Set price
	</ng-template>
	<span class="p-float-label">
		<p-dropdown
			#priceToggleSelection
			[options]="venueSvc.menuItemPriceOptions()"
			optionLabel="label"
			optionValue="value"
			name="priceToggleSelection"
			[(ngModel)]="togglePriceValueSelection"
			[style]="{ width: '100%' }"
			appendTo="body"
		></p-dropdown>
		<label for="priceToggleSelection">Price Number</label>
	</span>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]="true"
			[hideSave]=""
			(onCancelChange)="togglePrice = false; togglePriceValueSelection = undefined"
			(onSaveChange)="setAllPrice(togglePriceValueSelection); togglePrice = false"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="!togglePriceValueSelection"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
